export enum PermissionsEnum {
    Administrador = 1,
    Revisor = 2,
    Financeiro = 3,
    Vendas = 4,
    Fornecedor = 5,
    Publicar = 6,
    Editor = 7
}